import { Controller } from "@hotwired/stimulus"

// New room form: the members list only matters for a closed room.
export default class extends Controller {
  static targets = ["members"]

  change(event) {
    if (this.hasMembersTarget) this.membersTarget.hidden = event.target.value === "open"
  }
}
